// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__VHZiB","author":"Table_author__1xh0n","authorImage":"Table_authorImage__1Cbct","unreadRow":"Table_unreadRow__2iPk9"};